import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";

import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";



const AcademicProgram = () => {
  return (
    <>
      <PageHead title="Oferta Educativa - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Oferta Educativa" text="Oferta Educativa" />
          <div className=" bg-color-white mt--30 flex-center">
            <div className="container col-lg-8">
              <h4 className="title">PREESCOLAR: Transición</h4>
              <p className="description mt--30 mb--15">
                Grupos reducidos de sólo 18 niños por salón, con edad cumplida de 5 años.
              </p>
              <p className="description mt--15 mb--15">
                Nuestro enfoque se centra en el cuidado integral del SER, partiendo de sus conocimientos previos y apoyándolos en su desarrollo emocional, académico y normativo.
              </p>
              <p className="description mt--15">
                Todo esto lo logramos a través de profesores capacitados expertos en el manejo del aula, fomentando los valores y siguiendo nuestro proceso de convivencia, incluyendo las "Disculpas Menfisianas", una de las maneras más hermosas de fortalecer el carácter y el amor propio.
              </p>
              <h4 className="title">BÁSICA PRIMARIA: Primero, Segundo, Tercero, Cuarto y Quinto</h4>
              <p className="description mt--30">
                Ofrecemos grupos reducidos con un máximo de 18 niños y niñas por salón, lo que permite una atención más personalizada. Nuestro programa de bilingüismo intensifica el aprendizaje del inglés con 2 horas diarias dedicadas a este idioma. Áreas como Artística, Ciencias y Sociales se imparten en inglés, y en otras asignaturas integramos vocabulario, frases, comandos, canciones y conversaciones para reforzar el dominio del idioma. Una de nuestras grandes fortalezas es que este proceso está a cargo de docentes extranjeros, lo que garantiza un aprendizaje en inglés nativo y auténtico.
              </p>
              <h4 className="title">BÁSICA SECUNDARIA: Sexto, Séptimo, Octavo, Noveno y Décimo</h4>
              <p className="description mt--30">
                En Menfis, nuestros estudiantes que se encuentran entrando en su etapa de adolescencia, encuentran un entorno seguro donde pueden expresarse con libertad. Ofrecemos un aprendizaje personalizado, guiado por expertos en sus áreas, lo que favorece el desarrollo profundo del pensamiento crítico y creativo. Nos enfocamos en potenciar sus habilidades y talentos, brindando una formación integral que los prepara para enfrentar con éxito nuevos desafíos y oportunidades.
              </p>
              <p className="description mt--30 mb--30">
                En el Colegio Menfis, creemos firmemente en el poder transformador de la educación por eso desde el año 2023 iniciamos una gran alianza con la FUNDACIÓN MINGA HOUSE, generando un gran proyecto bilingüe. Nuestro proyecto de bilingüismo está diseñado para introducir a los estudiantes en el aprendizaje de un segundo idioma desde el inicio de su educación. Esta inmersión temprana en un entorno bilingüe ofrece numerosos beneficios que van más allá de la simple comunicación en otro idioma.
              </p>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default AcademicProgram;
